import { ring } from 'ldrs'
import logo from '../../assets/images/ball.png';
ring.register();

const Loader = () => {
    return (
        <div
            className="loader-container d-flex align-items-center justify-content-center"
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                zIndex: 9999,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                backgroundColor: 'white',
            }}
        >
            <img
                src={logo}
                alt="logo"
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '40px',
                    height: '40px', 
                }}
            />
            <l-ring
                size="65"
                stroke="5"
                bg-opacity="0"
                speed="2"
                color="#810B07"
            ></l-ring>
        </div>

    );
};

export default Loader; 